import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  chinaAreaList: [],
  allCountryList: [],
  certificateTypeOptions: [],
  logisticsCompanyOptions: [],
  allCityList: [],
};

function global(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.GLOBAL_CLEAR:
      result = INIT_STATE;
      break;
    // 获取中国的省市区数据
    case ACTION_TYPES.GET_CHINA_AREA_LIST:
      result.chinaAreaList = payload;
      break;
    // 获取所有国家列表
    case ACTION_TYPES.GET_ALL_COUNTRY_LIST:
      result.allCountryList = payload.records || [];
      break;
    // 获取证件类型下拉选项
    case ACTION_TYPES.GET_CERTIFICATE_TYPE_OPTIONS:
      result.certificateTypeOptions = payload;
      break;
    // 获取物流公司下拉选项
    case ACTION_TYPES.GET_LOGISTICS_COMPANY_OPTIONS:
      result.logisticsCompanyOptions = payload;
      break;
    // 获取所有城市列表
    case ACTION_TYPES.GET_ALL_CITY_LIST:
      result.allCityList = payload || [];
      break;
    default:
      result = state;
      break;
  }
  return result;
}

export default global;
